import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useOptimizationGenerationToast } from '../context/OptimizationGenerationToastContext';

const TARGET_PATHS = ['/home', '/optimizador'];

/**
 * After a successful job, closes the success toast when the user navigates to Dashboard or Optimizaciones.
 */
const OptimizationGenerationToastRouteSync = () => {
  const location = useLocation();
  const { closeSuccessToastOnRoute } = useOptimizationGenerationToast();
  const prevPathRef = useRef(null);

  useEffect(() => {
    const next = location.pathname;
    if (prevPathRef.current !== null && prevPathRef.current !== next && TARGET_PATHS.includes(next)) {
      closeSuccessToastOnRoute();
    }
    prevPathRef.current = next;
  }, [location.pathname, closeSuccessToastOnRoute]);

  return null;
};

export default OptimizationGenerationToastRouteSync;
